import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import './projboldquoteimage.css';
import { wordVariants, wrapperVariants } from "../ProjMinorQuoteTile/variants";


const ProjBoldQuoteImage = ({data, content, aspectRatio}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const { ref:upperRef, inView:upperInView, entry: upperEntry } = useInView({
        /* Optional options */
        triggerOnce: true,
        threshold: 0,
    });

    const { ref:lowerRef, inView:lowerInView, entry: lowerEntry } = useInView({
        /* Optional options */
        triggerOnce: true,
        threshold: 0,
    });

    const imgVariants = {
        initial: {
            opacity: 0
        }, animate: {
            opacity: 1,
            transition: {
                duration: 1,
                delay: 0
            }
        }, exit: {
            opacity: 0
        }
    }

    return(
        <>
            <div className="proj_img_quote__wrapper">
                <div className="proj_imgq_img__wrapper" style={{
                    aspectRatio: aspectRatio
                }}>
                    <img src={data.placeholder} style={{filter: "blur(6px)"}}/>
                    <motion.img 
                        initial="initial"
                        animate={isLoaded ? "animate" : "initial"}
                        exit="exit"
                        variants={imgVariants}
                        src={data.backgroundImage} 
                        onLoad={(e) => {
                            setIsLoaded(true);
                        } }
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                        }}
                    />
                </div>
                <div className="proj_imgq_quote__wrapper">
                    <motion.span
                        initial="initial"    
                        animate={upperInView ? "animate" : "initial"}
                        exit="exit"    
                        variants={wrapperVariants}
                        ref={upperRef}
                        className="l-q__wrapper"
                    >
                        {content.lastQuote[0].split(" ").map((word, idx) => (
                            <div><motion.span variants={wordVariants}>{word}&nbsp;</motion.span></div>
                        ))} 
                    </motion.span>
                    <motion.span className="l-q__wrapper hollow-text"
                        style={{
                            WebkitTextStrokeWidth: "2px"
                        }}
                        initial="initial"    
                        animate={lowerInView ? "animate" : "initial"}
                        exit="exit"    
                        variants={wrapperVariants}
                        ref={lowerRef}
                    >
                        {content.lastQuote[1].split(" ").map((word, idx) => (
                            <div><motion.span variants={wordVariants}>{word}&nbsp;</motion.span></div>
                        ))} 
                    </motion.span>
                </div>
            </div>
        </>
    )
}

export default ProjBoldQuoteImage;